import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { MailCheck, XCircle, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import SEO from '../components/SEO';

const VerifyEmailPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { verifyEmail } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState('verifying'); // verifying | ok | fail
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setState('fail');
      setMessage('Missing verification token.');
      return;
    }
    verifyEmail(token)
      .then(() => {
        setState('ok');
        toast.success('Email verified — welcome!');
      })
      .catch((err) => {
        setState('fail');
        setMessage(err.response?.data?.detail || 'Verification failed');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <SEO title="Verify email" path="/verify-email" noindex />
      <div className="bg-white border border-neutral-200 rounded-sm p-8 text-center" data-testid="verify-email-screen">
        {state === 'verifying' && (
          <>
            <Loader2 className="w-12 h-12 animate-spin text-[#F46A25] mx-auto mb-4" />
            <h1 className="text-xl font-black text-[#12263A]">Verifying your email...</h1>
          </>
        )}
        {state === 'ok' && (
          <>
            <MailCheck className="w-14 h-14 text-emerald-600 mx-auto mb-4" />
            <h1 className="text-2xl font-black text-[#12263A] mb-2">You're verified!</h1>
            <p className="text-sm text-neutral-600 mb-6">
              Your Dr Tools account is now active. Start browsing tools, materials and trade essentials.
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-[#F46A25] hover:bg-[#e05a15] text-white font-bold py-3 px-6 rounded-sm"
              data-testid="verify-continue-btn"
            >
              Continue shopping
            </button>
          </>
        )}
        {state === 'fail' && (
          <>
            <XCircle className="w-14 h-14 text-red-500 mx-auto mb-4" />
            <h1 className="text-2xl font-black text-[#12263A] mb-2">Verification failed</h1>
            <p className="text-sm text-neutral-600 mb-4">{message}</p>
            <Link to="/login" className="text-[#F46A25] font-bold hover:underline">
              Try signing in →
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
